import React, { useMemo, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import type { Office, User } from './types';
import UserTable from './user_table';
import PermissionCard from './permission_card';
import PageBreak from 'components/page_break';
import OfficeSelector from './office_selector';

type OupUserSelectorProps = {
  users: User[],
  initialSelectedUserIds: number[];
  initialSelectedOfficeIds: number[];
  officesById: { [key: number]: Office };
}
const OupUserSelector = (
  { users, initialSelectedUserIds, initialSelectedOfficeIds, officesById }: OupUserSelectorProps
) => {
  const initialRadioSelected = useMemo(() => {
    if (initialSelectedOfficeIds?.length > 0) {
      return 'offices';
    }
    if (initialSelectedUserIds?.length > 0) {
      return 'individual';
    }
    return 'all';
  }, [initialSelectedOfficeIds, initialSelectedUserIds]);

  const [radioSelected, setRadioSelected] = useState(initialRadioSelected);
  const showUserSelector = radioSelected === 'individual';

  return (
    <div>
      <h1>"Other Users" in Permissions refer to</h1>

      <Row>
        <Col xs={6}>
          <PermissionCard
            checked={radioSelected === 'all'}
            label="All Company Users"
            name="user[permissions_other_user_ids][]"
            subtitle="This user will be able to manage data for all the users at the company."
            onClick={() => setRadioSelected('all')}
          />
        </Col>
        <Col xs={6}>
          <PermissionCard
            checked={radioSelected === 'individual'}
            label="Individual Users"
            subtitle="This user will be able to manage data for the users selected below."
            onClick={() => setRadioSelected('individual')}
          />
        </Col>
        <Col xs={6}>
          <PermissionCard
            checked={radioSelected === 'offices'}
            label="Users in Specific Offices"
            subtitle="This user will be able to manage data for users in the specific offices selected below."
            onClick={() => setRadioSelected('offices')}
          />
        </Col>
      </Row>

      {showUserSelector && (
        <div>
          <PageBreak label="Select Individual Users" />
          <UserTable
            initialSelectedUserIds={initialSelectedUserIds}
            officesById={officesById}
            users={users}
          />
        </div>
      )}

      <OfficeSelector
        enable={radioSelected === 'offices'}
        initialSelectedOfficeIds={initialSelectedOfficeIds}
        officesById={officesById}
      />
    </div>
  );
};

export default OupUserSelector;
